import { render, staticRenderFns } from "./DisabledStylableTextarea.vue?vue&type=template&id=4d036a2e&scoped=true"
import script from "./DisabledStylableTextarea.vue?vue&type=script&lang=js"
export * from "./DisabledStylableTextarea.vue?vue&type=script&lang=js"
import style0 from "./DisabledStylableTextarea.vue?vue&type=style&index=0&id=4d036a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d036a2e",
  null
  
)

export default component.exports